import React, { MutableRefObject, ReactNode, useEffect, useRef } from "react";
import { shadows } from "src/constants";
import styled from "styled-components";

const Wrapper = styled.div<{
    position: string;
    isOpen: boolean;
    zIndex: number | string;
}>`
    display: ${props => (props.isOpen ? "flex" : "none")};
    position: absolute;
    z-index: ${props => props.zIndex};
    box-shadow: ${shadows.corner};
    ${props => props.position}
`;
interface Props {
    containerRef?: any;
    close: () => void;
    isOpen: boolean;
    position: string;
    children: ReactNode;
    className?: string;
    controlRef: any;
    persist?: boolean;
    zIndex?: string | number;
}

const Tooltip = ({
    close,
    isOpen,
    position,
    children,
    className,
    controlRef,
    zIndex = "auto"
}: Props) => {
    const ref = useRef() as MutableRefObject<HTMLDivElement>;
    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (
                ref.current &&
                !ref.current.contains(event.target as Node) &&
                !controlRef.current.contains(event.target as Node)
            ) {
                close();
            }
        };
        if (isOpen) {
            document.addEventListener("click", handleClickOutside, true);
        }
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [ref, controlRef, close, isOpen]);
    if (isOpen) {
        return (
            <Wrapper
                className={className}
                ref={ref}
                isOpen={isOpen}
                position={position}
                zIndex={zIndex}
            >
                {children}
            </Wrapper>
        );
    }
    return null;
};

export default Tooltip;
